import { CCard, CCardBody, CCol, CCardHeader, CRow } from '@coreui/react'
import {
    CChartBar,
    CChartDoughnut,
    CChartLine,
    CChartPie,
    CChartPolarArea,
    CChartRadar,
} from '@coreui/react-chartjs'
import { DocsCallout } from 'src/components';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox } from 'antd';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
const baseURL = apiUrls.baseURL;

const Bicycling = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState({ skip: 0, limit: 10 });
    const permissions = useSelector((state) => state.permissions.permissions);
    const accessShowInSite = permissions.includes('createblog');
    const navigate = useNavigate();
    const [loadingReport, setLoadingReport] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchData()
    }, [filter])


    const getReport = async () => {
        setLoadingReport(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/WorkingGroupCategory/GetExcelReport?id=5`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingReport(false)
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingReport(false)
        } finally {
            setLoadingReport(false)
        }
    }

    useEffect(() => {
        const loadNextPage = () => {
            const isAtBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            const hasMore = (data?.items?.length || 0) < (data?.count || 0);
            if (isAtBottom && hasMore && !loading) {
                setLoading(true);
                setFilter(current => ({ ...current, skip: current.skip + 1 }));
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, filter, loading]);
    const fetchData = async () => {

        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/program/getBicyclingNotifyPrograms?skip=${filter.skip}&limit=${filter.limit}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });

            var result = response.data.data;
            setData(previous => filter.skip === 0 ? result : { ...result, items: [...(previous?.items || []), ...(result?.items || [])] });
            setLoading(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    if (loading && !data?.items) {
        return <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 300
        }}><Spin size="large" /></div>
    }

    return (
        <div>
            {permissions.includes('bicyclingprogramsreport') && <div className="row program-list-report-row"><Button className="program-list-report-button" onClick={() => getReport()} loading={loadingReport}
                type="primary"><label>&#1711;&#1586;&#1575;&#1585;&#1588;</label></Button></div>}
            <div className='row'>
                <HideSidebarInMobileMode />
                {data?.items?.map((item, index) => {
                    return <Program
                        key={index}
                        programKey='bicycling'
                        color='rgb(213 243 245)'
                        item={item}
                        isShowOtherMember={true}
                        isShowRemainingCapacity={true}
                        isShowAssistantLeaderAmount={true}
                        onRefresh={() => { setData([]); setFilter(current => ({ ...current, skip: 0 })); }}>
                    </Program>
                })}
                {loading && <div style={{ textAlign: 'center', width: '100%', padding: 16 }}><Spin /></div>}
                <div style={{ textAlign: 'center', width: '100%', padding: 16 }}>&#1578;&#1593;&#1583;&#1575;&#1583; &#1705;&#1604;: {data?.count || 0} &#1576;&#1585;&#1606;&#1575;&#1605;&#1607;</div>
            </div>
        </div>
    )
}

export default Bicycling
